/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EntityRef } from './entityRef';

export interface GrantOut {
  id: string;
  kind: string;
  scope: string;
  grantee_user: EntityRef | null;
  grantee_level: string | null;
  grantee_entity: EntityRef | null;
  expires_at: string | null;
  created_by: EntityRef | null;
  created_at: string;
  revoked_at: string | null;
}
